import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareSummaryRoute: InvariantJiraRoute = {
	name: 'software-summary',
	path: '/jira/software/projects/:projectKey/summary',
};
